import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    account: {
        account: null, //string, required, minLength: 1 // Tài khoản
        password: null, //string, optional // Mật khẩu
        repassword: null, //string, optional // Mật khẩu
        //disabled: false, //boolean, required // Cho biết tài khoản có bị khóa hay không, nếu bị khóa, tài khoản sẽ không thể đăng nhập được
        roles: [], //array of string, required // Danh sách quyền của người dùng.
    },
    profile: {
        "ho_ten": {
            "ten": null,
            "ho": null,
            "ho_ten": null,
            "dinh_dang": "hoten"
        },
        "email": null,
        "dien_thoai": null,
        "gioi_tinh": null,
        "avatar_id": null
    },
    vhtt: {
        "province_id": undefined, // optional Mã tỉnh
        "district_id": undefined, // optional Mã huyện
    }
};

// validation form
model.validForm = {
    account: {
        account: [ValidService.required, ValidService.checkAccount], //string, required, minLength: 1 // Tài khoản
        password: [ValidService.required, ValidService.checkLengthMinimum(6)], //string, optional // Mật khẩu
        repassword: [ValidService.required, ValidService.checkLengthMinimum(6)], //string, optional // Mật khẩu
        //disabled: [], //boolean, required // Cho biết tài khoản có bị khóa hay không, nếu bị khóa, tài khoản sẽ không thể đăng nhập được
        roles: [ValidService.required],
    },
    profile: {
        "ho_ten": {
            "ho_ten": [ValidService.required],
        },
        "email": [ValidService.checkEmail],
        "dien_thoai": [ValidService.checkPhone],
    },
    vhtt: {
        "province_id": [ValidService.required,ValidService.requiredChange], // optional Mã tỉnh
        "district_id": [ValidService.required,ValidService.requiredChange], // optional Mã huyện
    }

};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

model.fileUploadOption = {
    AnhDaiDien: {
        limit: 1,
        accept: ".jpg, .png, .jpeg",
        dialogImageUrl: "",
        dialogVisible: false,
        fileList: []
    }
}

model.tableRules = {
    data: [],
    lengthMenu: [
        10,
        20,
        50,
        100,
        500
    ],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: [
        "account",
        "descending"
    ],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            account: "",
            roles: ""
        },
        operator: {
            account: ":regex_i:",
        }
    }
};

export default model;
